import { Fragment } from 'react';
import { Toolbar, ToolbarHeading, ToolbarPageTitle } from '@/partials/toolbar';
import { PageNavbar } from '@/pages/account';
import { useLayout } from '@/providers';
import { PoiRequestListings } from './components/PoiRequestListings';

const PoiRequestManagement = ({ harborId }: { harborId?: string | null }) => {
  const { currentLayout } = useLayout();

  return (
    <Fragment>
      <PageNavbar />
      {currentLayout?.name === 'demo1-layout' && (
        <Toolbar>
          <ToolbarHeading>
            <ToolbarPageTitle text="POI Requests" />
          </ToolbarHeading>
        </Toolbar>
      )}

      <PoiRequestListings harborId={harborId || null} />
    </Fragment>
  );
};

export { PoiRequestManagement };
